import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSwitch,{attrs:{"label":_vm.text,"inset":_vm.isInset,"disabled":_vm.disabled,"false-value":_vm.falseValue,"true-value":_vm.trueValue,"color":"primary"},on:{"change":_vm.emitChange},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }